module.exports = __webpack_public_path__ + "media/images/countryrect/ca-a4879e9304623e9da3be2350f609c93a.svg";